import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

const monthlyGrowth = [
  { month: 'Фев 2022', value: 0 },
  { month: 'Мар 2022', value: 150000 },
  { month: 'Апр 2022', value: 450000 },
  { month: 'Май 2022', value: 890000 },
  { month: 'Июн 2022', value: 1250000 },
  { month: 'Июл 2022', value: 1680000 },
  { month: 'Авг 2022', value: 2150000 },
  { month: 'Сен 2022', value: 2890000 },
  { month: 'Окт 2022', value: 3450000 },
  { month: 'Ноя 2022', value: 4120000 },
  { month: 'Дек 2022', value: 5280000 },
  { month: 'Янв 2023', value: 6450000 },
  { month: 'Фев 2023', value: 8291952 },
];

const maxMonthlyValue = Math.max(...monthlyGrowth.map(d => d.value));

const formatNumber = (num: number) =>
  new Intl.NumberFormat('ru-RU').format(num);

export default function CaseClothingForWomenPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 border border-[#C5A880]/20 rounded-full -mr-48 -mt-48"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 border border-[#C5A880]/20 rounded-full -ml-36 -mb-36"></div>
        <div className="absolute top-1/2 left-1/2 w-64 h-64 border border-[#C5A880]/10 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <Link
            to="/#cases"
            className="inline-flex items-center gap-2 text-[#C5A880] hover:text-white transition-colors mb-8 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            <span className="text-sm font-medium">Назад к кейсам</span>
          </Link>

          <div className="inline-block bg-[#C5A880] text-[#1A2B4C] px-5 py-2 rounded-full text-base font-bold mb-6 shadow-lg">
            📦 Проект на Маркетплейсах: Wildberries, Ozon
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Запуск Российского Производителя<br />одежды с 0 до 8,2 млн ₽
          </h1>
          <p className="text-[#C5A880]/90 text-xl mt-2 mb-10" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Женская одежда: Пальто женское и Спортивные женские брюки • Собственное производство • 212 SKU
          </p>

          {/* Key stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: 'ri-rocket-line', label: 'Старт', value: '0 ₽' },
              { icon: 'ri-trophy-line', label: 'Результат WB', value: '8,29 млн ₽' },
              { icon: 'ri-time-line', label: 'Период', value: '1 год' },
              { icon: 'ri-t-shirt-line', label: 'Ассортимент', value: '212 SKU' },
            ].map((stat, i) => (
              <div key={i} className="bg-white/5 backdrop-blur-sm rounded-2xl p-5 text-center border border-[#C5A880]/20 hover:border-[#C5A880]/40 transition-all duration-300">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                  <i className={`${stat.icon} text-2xl text-[#C5A880]`}></i>
                </div>
                <div className="text-2xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>{stat.value}</div>
                <div className="text-[#C5A880]/80 text-sm mt-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">

          {/* Challenge */}
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-[#C5A880] transition-all duration-300 group">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-flag-line text-xl text-[#C5A880]"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Playfair Display, serif' }}>Задача</h4>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Вывод бренда производителя на маркетплейсы «с нуля»
              </p>
              <div className="space-y-2">
                <div className="flex items-start gap-2 text-sm text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  <i className="ri-calendar-line text-[#C5A880] mt-0.5 flex-shrink-0"></i>
                  <span>Февраль 2022 (WB): <strong>0 руб.</strong></span>
                </div>
                <div className="flex items-start gap-2 text-sm text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  <i className="ri-calendar-line text-[#C5A880] mt-0.5 flex-shrink-0"></i>
                  <span>Октябрь 2022 (Ozon): <strong>0 руб.</strong></span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-[#C5A880] transition-all duration-300 group">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-t-shirt-line text-xl text-[#C5A880]"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Playfair Display, serif' }}>Сложность</h4>
              </div>
              <ul className="space-y-2 text-sm text-gray-700" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#C5A880] mt-0.5 flex-shrink-0"></i>
                  <span>Высококонкурентная ниша одежды</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#C5A880] mt-0.5 flex-shrink-0"></i>
                  <span>Управление большим ассортиментом (размеры, цвета)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#C5A880] mt-0.5 flex-shrink-0"></i>
                  <span>Сезонность товара</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-[#C5A880] transition-all duration-300 group">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-shopping-bag-line text-xl text-[#C5A880]"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Playfair Display, serif' }}>Масштаб</h4>
              </div>
              <div className="text-center mt-4">
                <div className="text-5xl font-bold text-[#C5A880] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>212</div>
                <p className="text-gray-600 text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>SKU (артикулов)</p>
                <p className="text-xs text-gray-500 mt-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>Верхняя одежда + Спортивные брюки</p>
              </div>
            </div>
          </div>

          {/* Special note */}
          <div className="bg-[#F8F9FA] border-l-4 border-[#C5A880] rounded-xl p-6 mb-16">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-xl text-[#C5A880]"></i>
              </div>
              <div>
                <h5 className="font-bold text-slate-900 mb-1 text-base" style={{ fontFamily: 'Playfair Display, serif' }}>Особенность проекта</h5>
                <p className="text-gray-700 text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Клиент — производитель. Мы управляли не просто кабинетом, а связкой <strong>«Производство — Маркетплейс»</strong>. Это требовало синхронизации производственного цикла с логистикой и сезонным спросом.
                </p>
              </div>
            </div>
          </div>

          {/* What We Did */}
          <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-8 md:p-10 text-white mb-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 border border-[#C5A880]/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 border border-[#C5A880]/10 rounded-full -ml-24 -mb-24"></div>
            
            <div className="relative z-10">
              <h2 className="text-3xl font-bold mb-6 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>⚙️ Что было сделано (Системный подход)</h2>
              <p className="text-xl text-[#C5A880]/90 text-center mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Стратегия «Управляющий Партнер» — контроль всех процессов запуска
              </p>

              <div className="grid md:grid-cols-2 gap-5">
                {[
                  {
                    icon: 'ri-database-2-line',
                    title: 'Работа с ассортиментом (212 SKU)',
                    items: [
                      'ABC-анализ товарной матрицы',
                      'Автоматизация (Excel + VBA) для 200+ товаров',
                    ],
                  },
                  {
                    icon: 'ri-file-text-line',
                    title: 'SEO и Контент',
                    items: [
                      'SEO-ядро для высокочастотных запросов',
                      'Оптимизация карточек для смежных категорий',
                    ],
                  },
                  {
                    icon: 'ri-truck-line',
                    title: 'Логистика и Планирование',
                    items: [
                      'График поставок с производства на склады',
                      'Избежание Out of Stock в сезон',
                    ],
                  },
                  {
                    icon: 'ri-advertisement-line',
                    title: 'Продвижение',
                    items: [
                      'Агрессивный запуск через внутреннюю рекламу',
                      'Участие в акциях с расчетом маржинальности',
                    ],
                  },
                ].map((item, i) => (
                  <div key={i} className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/20 hover:border-[#C5A880]/40 hover:bg-white/10 transition-all duration-300">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                        <i className={`${item.icon} text-2xl text-[#1A2B4C]`}></i>
                      </div>
                      <div>
                        <h5 className="text-lg font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>{item.title}</h5>
                        <ul className="space-y-1 text-sm text-[#C5A880]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                          {item.items.map((li, j) => (
                            <li key={j}>• {li}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ===== WILDBERRIES RESULTS ===== */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-slate-900 mb-4 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>📊 Результаты (Точка Б)</h2>
            <p className="text-center text-gray-600 mb-10 text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Стабильное масштабирование от месяца к месяцу на двух площадках
            </p>

            {/* WB Chart */}
            <div className="bg-white rounded-2xl p-8 shadow-xl mb-8 border border-gray-100">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-[#1A2B4C] rounded-xl flex items-center justify-center">
                  <i className="ri-line-chart-line text-3xl text-[#C5A880]"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Playfair Display, serif' }}>🟣 Wildberries</h3>
                  <p className="text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>Стабильное масштабирование от месяца к месяцу</p>
                </div>
              </div>

              {/* Bar Chart */}
              <div className="mb-6">
                <div className="relative h-64 flex items-end justify-between gap-2">
                  {monthlyGrowth.map((data, index) => (
                    <div key={index} className="flex-1 flex flex-col items-center">
                      <div className="w-full relative" style={{ height: '200px' }}>
                        <div
                          className={`absolute bottom-0 w-full ${index === monthlyGrowth.length - 1 ? 'bg-gradient-to-t from-[#C5A880] to-[#D4B890]' : 'bg-gradient-to-t from-[#1A2B4C] to-[#2A3B5C]'} rounded-t-lg transition-all duration-500 hover:opacity-80`}
                          style={{ height: `${(data.value / maxMonthlyValue) * 100}%` }}
                        >
                          {index === monthlyGrowth.length - 1 && (
                            <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-[#C5A880] text-[#1A2B4C] px-3 py-2 rounded-lg text-sm font-bold whitespace-nowrap shadow-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                              {formatNumber(data.value)} ₽
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="text-xs text-gray-600 mt-2 font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>{data.month}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Key Metrics */}
              <div className="grid grid-cols-3 gap-4 mb-8">
                <div className="bg-[#F8F9FA] rounded-xl p-4 text-center border border-[#C5A880]/20">
                  <div className="text-sm text-gray-600 mb-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>Период</div>
                  <div className="text-xl font-bold text-[#1A2B4C]" style={{ fontFamily: 'Playfair Display, serif' }}>Февраль 2023</div>
                </div>
                <div className="bg-[#F8F9FA] rounded-xl p-4 text-center border border-[#C5A880]/20">
                  <div className="text-sm text-gray-600 mb-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>Оборот</div>
                  <div className="text-xl font-bold text-[#C5A880]" style={{ fontFamily: 'Playfair Display, serif' }}>8 291 952 ₽</div>
                </div>
                <div className="bg-[#F8F9FA] rounded-xl p-4 text-center border border-[#C5A880]/20">
                  <div className="text-sm text-gray-600 mb-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>Продажи</div>
                  <div className="text-xl font-bold text-[#1A2B4C]" style={{ fontFamily: 'Playfair Display, serif' }}>5 415 шт</div>
                </div>
              </div>

              {/* Real Reports Screenshots */}
              <h4 className="text-lg font-bold text-slate-900 mb-4 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                📸 Реальные отчеты из личного кабинета Wildberries
              </h4>
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div className="bg-[#F8F9FA] rounded-xl p-4 shadow-lg border border-[#C5A880]/30">
                  <div className="mb-3 text-center">
                    <span className="inline-block bg-[#1A2B4C] text-[#C5A880] px-4 py-2 rounded-full text-sm font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      Отчет по продажам в рублях
                    </span>
                  </div>
                  <div className="bg-white rounded-lg overflow-hidden shadow-md border border-[#C5A880]/20">
                    <img
                      src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/de029b9703d6b3564cddd4c9991903b3.jpeg"
                      alt="Отчет по продажам февраль 2023 в рублях - 8 291 952 ₽"
                      className="w-full h-auto object-contain"
                    />
                  </div>
                  <div className="mt-3 text-center">
                    <p className="text-sm text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      <strong className="text-[#C5A880]">8 291 952 ₽</strong> — выручка за февраль 2023
                    </p>
                  </div>
                </div>

                <div className="bg-[#F8F9FA] rounded-xl p-4 shadow-lg border border-[#C5A880]/30">
                  <div className="mb-3 text-center">
                    <span className="inline-block bg-[#1A2B4C] text-[#C5A880] px-4 py-2 rounded-full text-sm font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      Отчет по продажам в штуках
                    </span>
                  </div>
                  <div className="bg-white rounded-lg overflow-hidden shadow-md border border-[#C5A880]/20">
                    <img
                      src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/7746fac13578dc221d49169b810c22e9.jpeg"
                      alt="Отчет по продажам февраль 2023 в штуках - 5 415 шт"
                      className="w-full h-auto object-contain"
                    />
                  </div>
                  <div className="mt-3 text-center">
                    <p className="text-sm text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      <strong className="text-[#C5A880]">5 415 шт</strong> — товаров выкуплено за февраль 2023
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-[#F8F9FA] border border-[#C5A880]/30 rounded-lg p-4 text-center mb-6">
                <p className="text-sm text-[#1A2B4C]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  <i className="ri-shield-check-line text-lg mr-2 text-[#C5A880]"></i>
                  <strong>Подтверждено реальными данными:</strong> Скриншоты из личного кабинета Wildberries
                </p>
              </div>

              <div className="bg-gradient-to-r from-[#1A2B4C] to-[#2A3B5C] rounded-xl p-6 text-center">
                <div className="text-white">
                  <div className="text-sm font-medium mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>Рост за 1 год</div>
                  <div className="text-4xl font-bold text-[#C5A880]" style={{ fontFamily: 'Playfair Display, serif' }}>с 0 до 8,29 млн ₽</div>
                  <div className="text-lg mt-2 opacity-90" style={{ fontFamily: 'Montserrat, sans-serif' }}>5 415 единиц товара выкуплено</div>
                </div>
              </div>
            </div>

            {/* ===== OZON RESULTS ===== */}
            <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-8 shadow-xl text-white">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-[#C5A880] rounded-xl flex items-center justify-center">
                  <i className="ri-store-line text-3xl text-[#1A2B4C]"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>🔵 Ozon</h3>
                  <p className="text-[#C5A880]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>Старт октябрь 2022 — март 2023</p>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4 mb-8">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-5 text-center border border-[#C5A880]/20">
                  <div className="text-sm text-[#C5A880]/80 mb-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>Период</div>
                  <div className="text-lg font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>Октябрь 2022 — Март 2023</div>
                </div>
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-5 border border-[#C5A880]/20">
                  <div className="text-sm text-[#C5A880]/80 mb-2 text-center" style={{ fontFamily: 'Montserrat, sans-serif' }}>Оборот по категориям</div>
                  <div className="space-y-1">
                    <div className="text-sm font-bold text-[#C5A880]" style={{ fontFamily: 'Montserrat, sans-serif' }}>Спортивные брюки женские — 1,3 млн ₽</div>
                    <div className="text-sm font-bold text-[#C5A880]" style={{ fontFamily: 'Montserrat, sans-serif' }}>Пальто женское — 5,2 млн ₽</div>
                  </div>
                </div>
              </div>

              {/* Ozon Competitive Position */}
              <h4 className="text-lg font-bold text-white mb-6 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                📸 Конкурентная позиция в категориях: До и После
              </h4>

              {/* Спортивные брюки */}
              <div className="mb-10">
                <h5 className="text-base font-bold text-white mb-4 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Категория: Спортивные брюки женские
                </h5>
                <div className="grid md:grid-cols-2 gap-6 mb-4">
                  <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 shadow-lg border border-[#C5A880]/20">
                    <div className="mb-3 text-center">
                      <span className="inline-block bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                        ❌ Было (2022)
                      </span>
                    </div>
                    <div className="bg-white rounded-lg overflow-hidden shadow-md border border-[#C5A880]/30">
                      <img
                        src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/4a9316c2bcd93655743228d3144712fd.png"
                        alt="Конкурентная позиция Ozon 2022 - Спортивные брюки женские"
                        className="w-full h-auto object-contain"
                      />
                    </div>
                  </div>
                  <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 shadow-lg border border-[#C5A880]/20">
                    <div className="mb-3 text-center">
                      <span className="inline-block bg-[#C5A880] text-[#1A2B4C] px-4 py-2 rounded-full text-sm font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                        ✅ Стало (март 2023)
                      </span>
                    </div>
                    <div className="bg-white rounded-lg overflow-hidden shadow-md border border-[#C5A880]/30">
                      <img
                        src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/38ede8a0a03a75db88ff43e82dbb8ab8.png"
                        alt="Конкурентная позиция Ozon 2023 - Спортивные брюки женские"
                        className="w-full h-auto object-contain"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Пальто женское */}
              <div className="mb-8">
                <h5 className="text-base font-bold text-white mb-4 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Категория: Пальто женское
                </h5>
                <div className="grid md:grid-cols-2 gap-6 mb-4">
                  <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 shadow-lg border border-[#C5A880]/20">
                    <div className="mb-3 text-center">
                      <span className="inline-block bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                        ❌ Было (2022)
                      </span>
                    </div>
                    <div className="bg-white rounded-lg overflow-hidden shadow-md border border-[#C5A880]/30">
                      <img
                        src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/7924063c69c1a361fe30aa4b5a58adc2.png"
                        alt="Конкурентная позиция Ozon 2022 - Пальто женское"
                        className="w-full h-auto object-contain"
                      />
                    </div>
                  </div>
                  <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 shadow-lg border border-[#C5A880]/20">
                    <div className="mb-3 text-center">
                      <span className="inline-block bg-[#C5A880] text-[#1A2B4C] px-4 py-2 rounded-full text-sm font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                        ✅ Стало (март 2023)
                      </span>
                    </div>
                    <div className="bg-white rounded-lg overflow-hidden shadow-md border border-[#C5A880]/30">
                      <img
                        src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/376762d41a33e661dd66a0a726a82e1a.png"
                        alt="Конкурентная позиция Ozon 2023 - Пальто женское"
                        className="w-full h-auto object-contain"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Achievement */}
              <div className="bg-white/5 border border-[#C5A880]/30 rounded-xl p-6 backdrop-blur-sm">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-medal-line text-xl text-[#1A2B4C]"></i>
                  </div>
                  <div>
                    <h6 className="font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>Достижение:</h6>
                    <p className="text-[#C5A880]/80 text-sm mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      Удалось вывести магазин на высокие позиции в поиске. Клиенты стали узнавать бренд и покупать товары.
                    </p>
                    <div className="space-y-2 text-sm text-white/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      <p>
                        Благодаря глубокой SEO-оптимизации карточек и работе с высокочастотными запросами, товары начали появляться на первых страницах поиска по ключевым запросам категорий.
                      </p>
                      <p>
                        ABC-анализ ассортимента и автоматизация управления 212 SKU позволили сфокусироваться на самых маржинальных позициях, что ускорило рост узнаваемости бренда.
                      </p>
                      <p>
                        Продуманная рекламная стратегия с участием в акциях и точный расчёт логистики обеспечили стабильное присутствие товаров на складах в пиковый сезон — клиенты всегда могли купить нужный размер и цвет.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Summary */}
          <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-8 mb-16 text-white">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-trophy-line text-2xl text-[#1A2B4C]"></i>
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-white mb-3 text-xl" style={{ fontFamily: 'Playfair Display, serif' }}>💡 Итог проекта</h3>
                <div className="grid md:grid-cols-3 gap-4 mb-4">
                  <div className="bg-white/5 rounded-xl p-4 text-center shadow-sm border border-[#C5A880]/20">
                    <div className="text-3xl font-bold text-[#C5A880] mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>8,29 млн ₽</div>
                    <div className="text-sm text-white/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>Wildberries (февраль 2023)</div>
                  </div>
                  <div className="bg-white/5 rounded-xl p-4 text-center shadow-sm border border-[#C5A880]/20">
                    <div className="text-3xl font-bold text-[#C5A880] mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>6,5 млн ₽</div>
                    <div className="text-sm text-white/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>Ozon (две категории)</div>
                  </div>
                  <div className="bg-white/5 rounded-xl p-4 text-center shadow-sm border border-[#C5A880]/20">
                    <div className="text-3xl font-bold text-[#C5A880] mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>5 415 шт</div>
                    <div className="text-sm text-white/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>Выкупленных товаров</div>
                  </div>
                </div>
                <div className="space-y-2 text-sm text-white/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  <p>
                    <strong>Связка «Производство — Маркетплейс»</strong> доказала свою эффективность: синхронизация производственного цикла с логистикой и сезонным спросом позволила избежать Out of Stock в пиковые периоды.
                  </p>
                  <p className="text-[#C5A880] font-semibold">
                    Системный подход: ABC-анализ + SEO + агрессивный запуск рекламы = выход в топ поиска на двух маркетплейсах за 1 год.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center py-12 bg-gradient-to-br from-[#F8F9FA] to-white rounded-3xl border border-[#C5A880]/30">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>Хотите запустить свой бренд на маркетплейсах?</h2>
            <p className="text-gray-600 text-lg mb-8 max-w-2xl mx-auto" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Хотите повторить этот результат в своей нише? Выстроим систему продаж с нуля.
            </p>
            <Link
              to="/#lead-form"
              className="inline-block bg-[#C5A880] text-[#1A2B4C] px-10 py-5 rounded-full text-xl font-bold hover:bg-[#D4B890] hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Запустить мой бренд на маркетплейсах
            </Link>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}